import { render, staticRenderFns } from "./CalculatedOrderListPartial.vue?vue&type=template&id=8c7bc43c&scoped=true&"
import script from "./CalculatedOrderListPartial.vue?vue&type=script&lang=js&"
export * from "./CalculatedOrderListPartial.vue?vue&type=script&lang=js&"
import style0 from "./CalculatedOrderListPartial.vue?vue&type=style&index=0&id=8c7bc43c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7bc43c",
  null
  
)

export default component.exports